// extracted by mini-css-extract-plugin
export default {"li":"List_li__y765Y","btn":"List_btn__+Y4CT","root":"List_root__+t17j"};